import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Standard class-name combiner: `clsx` for conditional truthiness, `tailwind-merge`
 * for de-duplicating conflicting Tailwind utilities (the later one wins).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
